import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=0fe0e42a&scoped=true&"
import script from "./addModule.vue?vue&type=script&lang=js&"
export * from "./addModule.vue?vue&type=script&lang=js&"
import style0 from "./addModule.vue?vue&type=style&index=0&id=0fe0e42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0e42a",
  null
  
)

component.options.__file = "addModule.vue"
export default component.exports